"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("./context");
const footerClass = (0, nano_theme_1.rule)({
    fls: '0',
    pos: 'absolute',
    l: 0,
    r: 0,
    b: 0,
    z: 20,
});
const Footer = ({ children, className, style, ...rest }) => {
    const state = (0, context_1.useScrollArea)();
    const ref = React.useRef(null);
    React.useLayoutEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        const observer = new ResizeObserver((entries) => {
            const entry = entries[0];
            if (entry)
                state.footerHeight$.next(entry.contentRect.height);
        });
        observer.observe(el);
        state.footerHeight$.next(el.offsetHeight);
        return () => {
            observer.disconnect();
            state.footerHeight$.next(0);
        };
    }, [state]);
    return (React.createElement("div", { ...rest, ref: ref, className: footerClass + (className ? ' ' + className : ''), style: style }, children));
};
exports.Footer = Footer;
